import React, { useState } from "react";
import config from '../../config'

const ModalAccept = ({ isOpen, onAccept, text }) => {

  const [accepted, setAccepted] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">

        <div className="container">
          <div className="row">
            <div className="col col-12 " style={{ backgroundColor: '#333', padding: '2px 0 0 15px' }}>
              <img src={config.headerLogo} alt={'Logo ' + config.headerTitle} style={{ margin: '0px' }} />
            </div>
          </div>
        </div>

        <p style={{ marginTop: '2rem' }}>
          <label style={{ cursor: 'pointer' }}>
            <input type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />
            {' '}{text}
          </label>
        </p>

        <div className="col col-12" align="center">
          <button className="button" disabled={!accepted} onClick={onAccept}>ACCEPTAR</button>
        </div>

      </div>
    </div>
  );
};

export default ModalAccept;
